import { useState } from 'react';
import { Image } from 'antd';
import { getImageThumb, getTiktokProxyImageSrc } from 'lib/utils/platformImage';
import SafeImageWrapper from 'components/SafeImage/SafeImage';
import { useMemoizedFn } from 'ahooks';
import useProxySrc from 'hooks/business/useProxySrc';

interface ProductImagesProps {
  images: string[];
  platform: General.PlatformUpperCaseTunnel | General.Platform;
  target?: Element | null;
}

export const ProductImages = (props: ProductImagesProps) => {
  const { images, platform, target } = props;

  const [visible, setVisible] = useState(false);

  const firstImageUrl = images?.[0];

  const { getProxyEnable, errorLog } = useProxySrc();

  const [error, setError] = useState<any>();

  const getFastImage = useMemoizedFn((image: string) => {
    if (!error && getProxyEnable(image)) {
      return getTiktokProxyImageSrc(image);
    }
    return image;
  });

  return (
    <>
      <SafeImageWrapper
        width={48}
        height={48}
        preview={false}
        hasSmallPic="both"
        src={getImageThumb(firstImageUrl, platform)}
        alt="product"
        target={target}
        onClick={() => setVisible(true)}
        onError={(error) => {
          setError(error);
          errorLog(getImageThumb(firstImageUrl, platform));
        }}
      />
      {images?.length > 0 && visible && (
        <div className="hidden">
          <Image.PreviewGroup preview={{ visible, onVisibleChange: setVisible }}>
            {images.map((image) => {
              return <Image key={image} src={getFastImage(image)} />;
            })}
          </Image.PreviewGroup>
        </div>
      )}
    </>
  );
};
